/* jQuery elevateZoom 3.0.8 - Demo's and documentation: - www.elevateweb.co.uk/image-zoom - Copyright (c) 2013 Andrew Eades - www.elevateweb.co.uk - Dual licensed under the LGPL licenses. - http://en.wikipedia.org/wiki/MIT_License - http://en.wikipedia.org/wiki/GNU_General_Public_License */
"function"!==typeof Object.create&&(Object.create=function(d){function h(){}h.prototype=d;return new h});
(function(d,h,l,m){var k={init:function(b,a){var c=this;c.elem=a;c.$elem=d(a);c.imageSrc=c.$elem.data("zoom-image")?c.$elem.data("zoom-image"):c.$elem.attr("src");c.options=d.extend({},d.fn.elevateZoom.options,b);c.options.tint&&(c.options.lensColour="none",c.options.lensOpacity="1");"inner"==c.options.zoomType&&(c.options.showLens=!1);c.$elem.parent().removeAttr("title").removeAttr("alt");c.zoomImage=c.imageSrc;c.refresh(1);d("#"+c.options.gallery+" a").click(function(a){c.options.galleryActiveClass&&
(d("#"+c.options.gallery+" a").removeClass(c.options.galleryActiveClass),d(this).addClass(c.options.galleryActiveClass));a.preventDefault();d(this).data("zoom-image")?c.zoomImagePre=d(this).data("zoom-image"):c.zoomImagePre=d(this).data("image");c.swaptheimage(d(this).data("image"),c.zoomImagePre);return!1})},refresh:function(b){var a=this;setTimeout(function(){a.fetch(a.imageSrc)},b||a.options.refresh)},fetch:function(b){var a=this,c=new Image;c.onload=function(){a.largeWidth=c.width;a.largeHeight=
c.height;a.startZoom();a.currentImage=a.imageSrc;a.options.onZoomedImageLoaded(a.$elem)};c.src=b},startZoom:function(){var b=this;b.nzWidth=b.$elem.width();b.nzHeight=b.$elem.height();b.isWindowActive=!1;b.isLensActive=!1;b.isTintActive=!1;b.overWindow=!1;b.options.imageCrossfade&&(b.zoomWrap=b.$elem.wrap('<div style="height:'+b.nzHeight+"px;width:"+b.nzWidth+'px;" class="zoomWrapper" />'),b.$elem.css("position","absolute"));b.zoomLock=1;b.scrollingLock=!1;b.changeBgSize=!1;b.currentZoomLevel=b.options.zoomLevel;
b.nzOffset=b.$elem.offset();b.widthRatio=b.largeWidth/b.currentZoomLevel/b.nzWidth;b.heightRatio=b.largeHeight/b.currentZoomLevel/b.nzHeight;"window"==b.options.zoomType&&(b.zoomWindowStyle="overflow: hidden;background-position: 0px 0px;text-align:center;background-color: "+String(b.options.zoomWindowBgColour)+";width: "+String(b.options.zoomWindowWidth)+"px;height: "+String(b.options.zoomWindowHeight)+"px;float: left;background-size: "+b.largeWidth/b.currentZoomLevel+"px "+b.largeHeight/b.currentZoomLevel+
"px;display: none;z-index:100;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;");if("inner"==b.options.zoomType){var a=b.$elem.css("border-left-width");b.zoomWindowStyle="overflow: hidden;margin-left: "+String(a)+";margin-top: "+String(a)+";background-position: 0px 0px;width: "+String(b.nzWidth)+"px;height: "+String(b.nzHeight)+"px;float: left;display: none;cursor:"+b.options.cursor+";px solid "+b.options.borderColour+";background-repeat: no-repeat;position: absolute;"}"window"==
b.options.zoomType&&(lensHeight=b.nzHeight<b.options.zoomWindowWidth/b.widthRatio?b.nzHeight:String(b.options.zoomWindowHeight/b.heightRatio),lensWidth=b.largeWidth<b.options.zoomWindowWidth?b.nzWidth:b.options.zoomWindowWidth/b.widthRatio,b.lensStyle="background-position: 0px 0px;width: "+String(b.options.zoomWindowWidth/b.widthRatio)+"px;height: "+String(b.options.zoomWindowHeight/b.heightRatio)+"px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:"+
b.options.lensOpacity+";filter: alpha(opacity = "+100*b.options.lensOpacity+"); zoom:1;width:"+lensWidth+"px;height:"+lensHeight+"px;background-color:"+b.options.lensColour+";cursor:"+b.options.cursor+";border: "+b.options.lensBorderSize+"px solid "+b.options.lensBorderColour+";background-repeat: no-repeat;position: absolute;");b.tintStyle="display: block;position: absolute;background-color: "+b.options.tintColour+";filter:alpha(opacity=0);opacity: 0;width: "+b.nzWidth+"px;height: "+b.nzHeight+"px;";
b.lensRound="";"lens"==b.options.zoomType&&(b.lensStyle="background-position: 0px 0px;float: left;display: none;border: "+String(b.options.borderSize)+"px solid "+b.options.borderColour+";width:"+String(b.options.lensSize)+"px;height:"+String(b.options.lensSize)+"px;background-repeat: no-repeat;position: absolute;");"round"==b.options.lensShape&&(b.lensRound="border-top-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-top-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+
"px;border-bottom-left-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;border-bottom-right-radius: "+String(b.options.lensSize/2+b.options.borderSize)+"px;");b.zoomContainer=d('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:'+b.nzOffset.left+"px;top:"+b.nzOffset.top+"px;height:"+b.nzHeight+"px;width:"+b.nzWidth+'px;"></div>');d("body").append(b.zoomContainer);b.options.containLensZoom&&"lens"==b.options.zoomType&&b.zoomContainer.css("overflow",
"hidden");"inner"!=b.options.zoomType&&(b.zoomLens=d("<div class='zoomLens' style='"+b.lensStyle+b.lensRound+"'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")}),b.options.tint&&(b.tintContainer=d("<div/>").addClass("tintContainer"),b.zoomTint=d("<div class='zoomTint' style='"+b.tintStyle+"'></div>"),b.zoomLens.wrap(b.tintContainer),b.zoomTintcss=b.zoomLens.after(b.zoomTint),b.zoomTintImage=d('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: '+
b.nzWidth+"px; height: "+b.nzHeight+'px;" src="'+b.imageSrc+'">').appendTo(b.zoomLens).click(function(){b.$elem.trigger("click")})));isNaN(b.options.zoomWindowPosition)?b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+"' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function(){b.$elem.trigger("click")}):b.zoomWindow=d("<div style='z-index:999;left:"+b.windowOffsetLeft+"px;top:"+b.windowOffsetTop+"px;"+b.zoomWindowStyle+
"' class='zoomWindow'>&nbsp;</div>").appendTo(b.zoomContainer).click(function(){b.$elem.trigger("click")});b.zoomWindowContainer=d("<div/>").addClass("zoomWindowContainer").css("width",b.options.zoomWindowWidth);b.zoomWindow.wrap(b.zoomWindowContainer);"lens"==b.options.zoomType&&b.zoomLens.css({backgroundImage:"url('"+b.imageSrc+"')"});"window"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+"')"});"inner"==b.options.zoomType&&b.zoomWindow.css({backgroundImage:"url('"+b.imageSrc+
"')"});b.$elem.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchmove",function(a){"inner"==b.options.zoomType&&b.showHideWindow("show");a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])});b.zoomContainer.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});
b.$elem.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")});b.options.showLens&&(b.zoomLens.bind("touchmove",function(a){a.preventDefault();b.setPosition(a.originalEvent.touches[0]||a.originalEvent.changedTouches[0])}),b.zoomLens.bind("touchend",function(a){b.showHideWindow("hide");b.options.showLens&&b.showHideLens("hide");b.options.tint&&"inner"!=b.options.zoomType&&b.showHideTint("hide")}));
b.$elem.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.bind("mousemove",function(a){!1==b.overWindow&&b.setElements("show");if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"!=b.options.zoomType&&b.zoomLens.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),
b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.options.tint&&"inner"!=b.options.zoomType&&b.zoomTint.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});"inner"==b.options.zoomType&&b.zoomWindow.bind("mousemove",function(a){if(b.lastX!==a.clientX||b.lastY!==a.clientY)b.setPosition(a),b.currentLoc=a;b.lastX=a.clientX;b.lastY=a.clientY});b.zoomContainer.add(b.$elem).mouseenter(function(){!1==b.overWindow&&
b.setElements("show")}).mouseleave(function(){b.scrollLock||b.setElements("hide")});"inner"!=b.options.zoomType&&b.zoomWindow.mouseenter(function(){b.overWindow=!0;b.setElements("hide")}).mouseleave(function(){b.overWindow=!1});b.minZoomLevel=b.options.minZoomLevel?b.options.minZoomLevel:2*b.options.scrollZoomIncrement;b.options.scrollZoom&&b.zoomContainer.add(b.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll",function(a){b.scrollLock=!0;clearTimeout(d.data(this,"timer"));d.data(this,"timer",
setTimeout(function(){b.scrollLock=!1},250));var e=a.originalEvent.wheelDelta||-1*a.originalEvent.detail;a.stopImmediatePropagation();a.stopPropagation();a.preventDefault();0<e/120?b.currentZoomLevel>=b.minZoomLevel&&b.changeZoomLevel(b.currentZoomLevel-b.options.scrollZoomIncrement):b.options.maxZoomLevel?b.currentZoomLevel<=b.options.maxZoomLevel&&b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement):b.changeZoomLevel(parseFloat(b.currentZoomLevel)+b.options.scrollZoomIncrement);
return!1})},setElements:function(b){if(!this.options.zoomEnabled)return!1;"show"==b&&this.isWindowSet&&("inner"==this.options.zoomType&&this.showHideWindow("show"),"window"==this.options.zoomType&&this.showHideWindow("show"),this.options.showLens&&this.showHideLens("show"),this.options.tint&&"inner"!=this.options.zoomType&&this.showHideTint("show"));"hide"==b&&("window"==this.options.zoomType&&this.showHideWindow("hide"),this.options.tint||this.showHideWindow("hide"),this.options.showLens&&this.showHideLens("hide"),
this.options.tint&&this.showHideTint("hide"))},setPosition:function(b){if(!this.options.zoomEnabled)return!1;this.nzHeight=this.$elem.height();this.nzWidth=this.$elem.width();this.nzOffset=this.$elem.offset();this.options.tint&&"inner"!=this.options.zoomType&&(this.zoomTint.css({top:0}),this.zoomTint.css({left:0}));this.options.responsive&&!this.options.scrollZoom&&this.options.showLens&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/
this.heightRatio),lensWidth=this.largeWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.widthRatio=this.largeWidth/this.nzWidth,this.heightRatio=this.largeHeight/this.nzHeight,"lens"!=this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/
this.widthRatio,this.zoomLens.css("width",lensWidth),this.zoomLens.css("height",lensHeight),this.options.tint&&(this.zoomTintImage.css("width",this.nzWidth),this.zoomTintImage.css("height",this.nzHeight))),"lens"==this.options.zoomType&&this.zoomLens.css({width:String(this.options.lensSize)+"px",height:String(this.options.lensSize)+"px"}));this.zoomContainer.css({top:this.nzOffset.top});this.zoomContainer.css({left:this.nzOffset.left});this.mouseLeft=parseInt(b.pageX-this.nzOffset.left);this.mouseTop=
parseInt(b.pageY-this.nzOffset.top);"window"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.zoomLens.height()/2,this.Eboppos=this.mouseTop>this.nzHeight-this.zoomLens.height()/2-2*this.options.lensBorderSize,this.Eloppos=this.mouseLeft<0+this.zoomLens.width()/2,this.Eroppos=this.mouseLeft>this.nzWidth-this.zoomLens.width()/2-2*this.options.lensBorderSize);"inner"==this.options.zoomType&&(this.Etoppos=this.mouseTop<this.nzHeight/2/this.heightRatio,this.Eboppos=this.mouseTop>this.nzHeight-
this.nzHeight/2/this.heightRatio,this.Eloppos=this.mouseLeft<0+this.nzWidth/2/this.widthRatio,this.Eroppos=this.mouseLeft>this.nzWidth-this.nzWidth/2/this.widthRatio-2*this.options.lensBorderSize);0>=this.mouseLeft||0>this.mouseTop||this.mouseLeft>this.nzWidth||this.mouseTop>this.nzHeight?this.setElements("hide"):(this.options.showLens&&(this.lensLeftPos=String(this.mouseLeft-this.zoomLens.width()/2),this.lensTopPos=String(this.mouseTop-this.zoomLens.height()/2)),this.Etoppos&&(this.lensTopPos=0),
this.Eloppos&&(this.tintpos=this.lensLeftPos=this.windowLeftPos=0),"window"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize)),"inner"==this.options.zoomType&&(this.Eboppos&&(this.lensTopPos=Math.max(this.nzHeight-2*this.options.lensBorderSize,0)),this.Eroppos&&(this.lensLeftPos=this.nzWidth-this.nzWidth-2*this.options.lensBorderSize)),
"lens"==this.options.zoomType&&(this.windowLeftPos=String(-1*((b.pageX-this.nzOffset.left)*this.widthRatio-this.zoomLens.width()/2)),this.windowTopPos=String(-1*((b.pageY-this.nzOffset.top)*this.heightRatio-this.zoomLens.height()/2)),this.zoomLens.css({backgroundPosition:this.windowLeftPos+"px "+this.windowTopPos+"px"}),this.changeBgSize&&(this.nzHeight>this.nzWidth?("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+
"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvalueheight+"px "+this.largeHeight/this.newvalueheight+"px"})):("lens"==this.options.zoomType&&this.zoomLens.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"}),this.zoomWindow.css({"background-size":this.largeWidth/this.newvaluewidth+"px "+this.largeHeight/this.newvaluewidth+"px"})),this.changeBgSize=!1),this.setWindowPostition(b)),this.options.tint&&"inner"!=this.options.zoomType&&
this.setTintPosition(b),"window"==this.options.zoomType&&this.setWindowPostition(b),"inner"==this.options.zoomType&&this.setWindowPostition(b),this.options.showLens&&(this.fullwidth&&"lens"!=this.options.zoomType&&(this.lensLeftPos=0),this.zoomLens.css({left:this.lensLeftPos+"px",top:this.lensTopPos+"px"})))},showHideWindow:function(b){"show"!=b||this.isWindowActive||(this.options.zoomWindowFadeIn?this.zoomWindow.stop(!0,!0,!1).fadeIn(this.options.zoomWindowFadeIn):this.zoomWindow.show(),this.isWindowActive=
!0);"hide"==b&&this.isWindowActive&&(this.options.zoomWindowFadeOut?this.zoomWindow.stop(!0,!0).fadeOut(this.options.zoomWindowFadeOut):this.zoomWindow.hide(),this.isWindowActive=!1)},showHideLens:function(b){"show"!=b||this.isLensActive||(this.options.lensFadeIn?this.zoomLens.stop(!0,!0,!1).fadeIn(this.options.lensFadeIn):this.zoomLens.show(),this.isLensActive=!0);"hide"==b&&this.isLensActive&&(this.options.lensFadeOut?this.zoomLens.stop(!0,!0).fadeOut(this.options.lensFadeOut):this.zoomLens.hide(),
this.isLensActive=!1)},showHideTint:function(b){"show"!=b||this.isTintActive||(this.options.zoomTintFadeIn?this.zoomTint.css({opacity:this.options.tintOpacity}).animate().stop(!0,!0).fadeIn("slow"):(this.zoomTint.css({opacity:this.options.tintOpacity}).animate(),this.zoomTint.show()),this.isTintActive=!0);"hide"==b&&this.isTintActive&&(this.options.zoomTintFadeOut?this.zoomTint.stop(!0,!0).fadeOut(this.options.zoomTintFadeOut):this.zoomTint.hide(),this.isTintActive=!1)},setLensPostition:function(b){},
setWindowPostition:function(b){var a=this;if(isNaN(a.options.zoomWindowPosition))a.externalContainer=d("#"+a.options.zoomWindowPosition),a.externalContainerWidth=a.externalContainer.width(),a.externalContainerHeight=a.externalContainer.height(),a.externalContainerOffset=a.externalContainer.offset(),a.windowOffsetTop=a.externalContainerOffset.top,a.windowOffsetLeft=a.externalContainerOffset.left;else switch(a.options.zoomWindowPosition){case 1:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=
+a.nzWidth;break;case 2:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=a.nzWidth);break;case 3:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=a.nzWidth;break;case 4:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth;break;case 5:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 6:a.options.zoomWindowHeight>
a.nzHeight&&(a.windowOffsetTop=a.nzHeight,a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 7:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=0;break;case 8:a.windowOffsetTop=a.nzHeight;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 9:a.windowOffsetTop=a.nzHeight-a.zoomWindow.height()-2*a.options.borderSize;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 10:a.options.zoomWindowHeight>a.nzHeight&&
(a.windowOffsetTop=-1*(a.options.zoomWindowHeight/2-a.nzHeight/2),a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize));break;case 11:a.windowOffsetTop=a.options.zoomWindowOffety;a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 12:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=-1*(a.zoomWindow.width()+2*a.options.borderSize);break;case 13:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=
0;break;case 14:a.options.zoomWindowHeight>a.nzHeight&&(a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize),a.windowOffsetLeft=-1*(a.options.zoomWindowWidth/2-a.nzWidth/2+2*a.options.borderSize));break;case 15:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth-a.zoomWindow.width()-2*a.options.borderSize;break;case 16:a.windowOffsetTop=-1*(a.zoomWindow.height()+2*a.options.borderSize);a.windowOffsetLeft=a.nzWidth;break;default:a.windowOffsetTop=
a.options.zoomWindowOffety,a.windowOffsetLeft=a.nzWidth}a.isWindowSet=!0;a.windowOffsetTop+=a.options.zoomWindowOffety;a.windowOffsetLeft+=a.options.zoomWindowOffetx;a.zoomWindow.css({top:a.windowOffsetTop});a.zoomWindow.css({left:a.windowOffsetLeft});"inner"==a.options.zoomType&&(a.zoomWindow.css({top:0}),a.zoomWindow.css({left:0}));a.windowLeftPos=String(-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2));a.windowTopPos=String(-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/
2));a.Etoppos&&(a.windowTopPos=0);a.Eloppos&&(a.windowLeftPos=0);a.Eboppos&&(a.windowTopPos=-1*(a.largeHeight/a.currentZoomLevel-a.zoomWindow.height()));a.Eroppos&&(a.windowLeftPos=-1*(a.largeWidth/a.currentZoomLevel-a.zoomWindow.width()));a.fullheight&&(a.windowTopPos=0);a.fullwidth&&(a.windowLeftPos=0);if("window"==a.options.zoomType||"inner"==a.options.zoomType)1==a.zoomLock&&(1>=a.widthRatio&&(a.windowLeftPos=0),1>=a.heightRatio&&(a.windowTopPos=0)),a.largeHeight<a.options.zoomWindowHeight&&(a.windowTopPos=
0),a.largeWidth<a.options.zoomWindowWidth&&(a.windowLeftPos=0),a.options.easing?(a.xp||(a.xp=0),a.yp||(a.yp=0),a.loop||(a.loop=setInterval(function(){a.xp+=(a.windowLeftPos-a.xp)/a.options.easingAmount;a.yp+=(a.windowTopPos-a.yp)/a.options.easingAmount;a.scrollingLock?(clearInterval(a.loop),a.xp=a.windowLeftPos,a.yp=a.windowTopPos,a.xp=-1*((b.pageX-a.nzOffset.left)*a.widthRatio-a.zoomWindow.width()/2),a.yp=-1*((b.pageY-a.nzOffset.top)*a.heightRatio-a.zoomWindow.height()/2),a.changeBgSize&&(a.nzHeight>
a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),
a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+"px "+a.windowTopPos+"px"}),a.scrollingLock=!1,a.loop=!1):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})):("lens"!=a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+
"px "+a.largeHeight/a.newvaluewidth+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.xp+"px "+a.yp+"px"}))},16))):(a.changeBgSize&&(a.nzHeight>a.nzWidth?("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"}),a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/
a.newvalueheight+"px"})):("lens"==a.options.zoomType&&a.zoomLens.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}),a.largeHeight/a.newvaluewidth<a.options.zoomWindowHeight?a.zoomWindow.css({"background-size":a.largeWidth/a.newvaluewidth+"px "+a.largeHeight/a.newvaluewidth+"px"}):a.zoomWindow.css({"background-size":a.largeWidth/a.newvalueheight+"px "+a.largeHeight/a.newvalueheight+"px"})),a.changeBgSize=!1),a.zoomWindow.css({backgroundPosition:a.windowLeftPos+
"px "+a.windowTopPos+"px"}))},setTintPosition:function(b){this.nzOffset=this.$elem.offset();this.tintpos=String(-1*(b.pageX-this.nzOffset.left-this.zoomLens.width()/2));this.tintposy=String(-1*(b.pageY-this.nzOffset.top-this.zoomLens.height()/2));this.Etoppos&&(this.tintposy=0);this.Eloppos&&(this.tintpos=0);this.Eboppos&&(this.tintposy=-1*(this.nzHeight-this.zoomLens.height()-2*this.options.lensBorderSize));this.Eroppos&&(this.tintpos=-1*(this.nzWidth-this.zoomLens.width()-2*this.options.lensBorderSize));
this.options.tint&&(this.fullheight&&(this.tintposy=0),this.fullwidth&&(this.tintpos=0),this.zoomTintImage.css({left:this.tintpos+"px"}),this.zoomTintImage.css({top:this.tintposy+"px"}))},swaptheimage:function(b,a){var c=this,e=new Image;c.options.loadingIcon&&(c.spinner=d("<div style=\"background: url('"+c.options.loadingIcon+"') no-repeat center;height:"+c.nzHeight+"px;width:"+c.nzWidth+'px;z-index: 2000;position: absolute; background-position: center center;"></div>'),c.$elem.after(c.spinner));
c.options.onImageSwap(c.$elem);e.onload=function(){c.largeWidth=e.width;c.largeHeight=e.height;c.zoomImage=a;c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.zoomWindow.css({"background-size":c.largeWidth+"px "+c.largeHeight+"px"});c.swapAction(b,a)};e.src=a},swapAction:function(b,a){var c=this,e=new Image;e.onload=function(){c.nzHeight=e.height;c.nzWidth=e.width;c.options.onImageSwapComplete(c.$elem);c.doneCallback()};e.src=b;c.currentZoomLevel=c.options.zoomLevel;c.options.maxZoomLevel=
!1;"lens"==c.options.zoomType&&c.zoomLens.css({backgroundImage:"url('"+a+"')"});"window"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});"inner"==c.options.zoomType&&c.zoomWindow.css({backgroundImage:"url('"+a+"')"});c.currentImage=a;if(c.options.imageCrossfade){var f=c.$elem,g=f.clone();c.$elem.attr("src",b);c.$elem.after(g);g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()});c.$elem.width("auto").removeAttr("width");c.$elem.height("auto").removeAttr("height");
f.fadeIn(c.options.imageCrossfade);c.options.tint&&"inner"!=c.options.zoomType&&(f=c.zoomTintImage,g=f.clone(),c.zoomTintImage.attr("src",a),c.zoomTintImage.after(g),g.stop(!0).fadeOut(c.options.imageCrossfade,function(){d(this).remove()}),f.fadeIn(c.options.imageCrossfade),c.zoomTint.css({height:c.$elem.height()}),c.zoomTint.css({width:c.$elem.width()}));c.zoomContainer.css("height",c.$elem.height());c.zoomContainer.css("width",c.$elem.width());"inner"!=c.options.zoomType||c.options.constrainType||
(c.zoomWrap.parent().css("height",c.$elem.height()),c.zoomWrap.parent().css("width",c.$elem.width()),c.zoomWindow.css("height",c.$elem.height()),c.zoomWindow.css("width",c.$elem.width()))}else c.$elem.attr("src",b),c.options.tint&&(c.zoomTintImage.attr("src",a),c.zoomTintImage.attr("height",c.$elem.height()),c.zoomTintImage.css({height:c.$elem.height()}),c.zoomTint.css({height:c.$elem.height()})),c.zoomContainer.css("height",c.$elem.height()),c.zoomContainer.css("width",c.$elem.width());c.options.imageCrossfade&&
(c.zoomWrap.css("height",c.$elem.height()),c.zoomWrap.css("width",c.$elem.width()));c.options.constrainType&&("height"==c.options.constrainType&&(c.zoomContainer.css("height",c.options.constrainSize),c.zoomContainer.css("width","auto"),c.options.imageCrossfade?(c.zoomWrap.css("height",c.options.constrainSize),c.zoomWrap.css("width","auto"),c.constwidth=c.zoomWrap.width()):(c.$elem.css("height",c.options.constrainSize),c.$elem.css("width","auto"),c.constwidth=c.$elem.width()),"inner"==c.options.zoomType&&
(c.zoomWrap.parent().css("height",c.options.constrainSize),c.zoomWrap.parent().css("width",c.constwidth),c.zoomWindow.css("height",c.options.constrainSize),c.zoomWindow.css("width",c.constwidth)),c.options.tint&&(c.tintContainer.css("height",c.options.constrainSize),c.tintContainer.css("width",c.constwidth),c.zoomTint.css("height",c.options.constrainSize),c.zoomTint.css("width",c.constwidth),c.zoomTintImage.css("height",c.options.constrainSize),c.zoomTintImage.css("width",c.constwidth))),"width"==
c.options.constrainType&&(c.zoomContainer.css("height","auto"),c.zoomContainer.css("width",c.options.constrainSize),c.options.imageCrossfade?(c.zoomWrap.css("height","auto"),c.zoomWrap.css("width",c.options.constrainSize),c.constheight=c.zoomWrap.height()):(c.$elem.css("height","auto"),c.$elem.css("width",c.options.constrainSize),c.constheight=c.$elem.height()),"inner"==c.options.zoomType&&(c.zoomWrap.parent().css("height",c.constheight),c.zoomWrap.parent().css("width",c.options.constrainSize),c.zoomWindow.css("height",
c.constheight),c.zoomWindow.css("width",c.options.constrainSize)),c.options.tint&&(c.tintContainer.css("height",c.constheight),c.tintContainer.css("width",c.options.constrainSize),c.zoomTint.css("height",c.constheight),c.zoomTint.css("width",c.options.constrainSize),c.zoomTintImage.css("height",c.constheight),c.zoomTintImage.css("width",c.options.constrainSize))))},doneCallback:function(){this.options.loadingIcon&&this.spinner.hide();this.nzOffset=this.$elem.offset();this.nzWidth=this.$elem.width();
this.nzHeight=this.$elem.height();this.currentZoomLevel=this.options.zoomLevel;this.widthRatio=this.largeWidth/this.nzWidth;this.heightRatio=this.largeHeight/this.nzHeight;"window"==this.options.zoomType&&(lensHeight=this.nzHeight<this.options.zoomWindowWidth/this.widthRatio?this.nzHeight:String(this.options.zoomWindowHeight/this.heightRatio),lensWidth=this.options.zoomWindowWidth<this.options.zoomWindowWidth?this.nzWidth:this.options.zoomWindowWidth/this.widthRatio,this.zoomLens&&(this.zoomLens.css("width",
lensWidth),this.zoomLens.css("height",lensHeight)))},getCurrentImage:function(){return this.zoomImage},getGalleryList:function(){var b=this;b.gallerylist=[];b.options.gallery?d("#"+b.options.gallery+" a").each(function(){var a="";d(this).data("zoom-image")?a=d(this).data("zoom-image"):d(this).data("image")&&(a=d(this).data("image"));a==b.zoomImage?b.gallerylist.unshift({href:""+a+"",title:d(this).find("img").attr("title")}):b.gallerylist.push({href:""+a+"",title:d(this).find("img").attr("title")})}):
b.gallerylist.push({href:""+b.zoomImage+"",title:d(this).find("img").attr("title")});return b.gallerylist},changeZoomLevel:function(b){this.scrollingLock=!0;this.newvalue=parseFloat(b).toFixed(2);newvalue=parseFloat(b).toFixed(2);maxheightnewvalue=this.largeHeight/(this.options.zoomWindowHeight/this.nzHeight*this.nzHeight);maxwidthtnewvalue=this.largeWidth/(this.options.zoomWindowWidth/this.nzWidth*this.nzWidth);"inner"!=this.options.zoomType&&(maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
maxheightnewvalue/this.nzHeight,this.newvalueheight=maxheightnewvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/maxwidthtnewvalue/this.nzWidth,this.newvaluewidth=maxwidthtnewvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1),"lens"==this.options.zoomType&&(maxheightnewvalue<=newvalue?
(this.fullwidth=!0,this.newvaluewidth=maxheightnewvalue):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue,this.fullwidth=!1)));"inner"==this.options.zoomType&&(maxheightnewvalue=parseFloat(this.largeHeight/this.nzHeight).toFixed(2),maxwidthtnewvalue=parseFloat(this.largeWidth/this.nzWidth).toFixed(2),newvalue>maxheightnewvalue&&(newvalue=maxheightnewvalue),newvalue>maxwidthtnewvalue&&(newvalue=maxwidthtnewvalue),maxheightnewvalue<=newvalue?(this.heightRatio=this.largeHeight/
newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!0):(this.heightRatio=this.largeHeight/newvalue/this.nzHeight,this.newvalueheight=newvalue>maxheightnewvalue?maxheightnewvalue:newvalue,this.fullheight=!1),maxwidthtnewvalue<=newvalue?(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=newvalue>maxwidthtnewvalue?maxwidthtnewvalue:newvalue,this.fullwidth=!0):(this.widthRatio=this.largeWidth/newvalue/this.nzWidth,this.newvaluewidth=
newvalue,this.fullwidth=!1));scrcontinue=!1;"inner"==this.options.zoomType&&(this.nzWidth>this.nzHeight&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)),this.nzHeight>this.nzWidth&&(this.newvaluewidth<=maxwidthtnewvalue?scrcontinue=!0:(scrcontinue=!1,this.fullwidth=this.fullheight=!0)));"inner"!=this.options.zoomType&&(scrcontinue=!0);scrcontinue&&(this.zoomLock=0,this.changeZoom=!0,this.options.zoomWindowHeight/this.heightRatio<=this.nzHeight&&
(this.currentZoomLevel=this.newvalueheight,"lens"!=this.options.zoomType&&"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({height:String(this.options.zoomWindowHeight/this.heightRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),this.options.zoomWindowWidth/this.widthRatio<=this.nzWidth&&("inner"!=this.options.zoomType&&this.newvaluewidth>this.newvalueheight&&(this.currentZoomLevel=this.newvaluewidth),"lens"!=this.options.zoomType&&
"inner"!=this.options.zoomType&&(this.changeBgSize=!0,this.zoomLens.css({width:String(this.options.zoomWindowWidth/this.widthRatio)+"px"})),"lens"==this.options.zoomType||"inner"==this.options.zoomType)&&(this.changeBgSize=!0),"inner"==this.options.zoomType&&(this.changeBgSize=!0,this.nzWidth>this.nzHeight&&(this.currentZoomLevel=this.newvaluewidth),this.nzHeight>this.nzWidth&&(this.currentZoomLevel=this.newvaluewidth)));this.setPosition(this.currentLoc)},closeAll:function(){self.zoomWindow&&self.zoomWindow.hide();
self.zoomLens&&self.zoomLens.hide();self.zoomTint&&self.zoomTint.hide()},changeState:function(b){"enable"==b&&(this.options.zoomEnabled=!0);"disable"==b&&(this.options.zoomEnabled=!1)}};d.fn.elevateZoom=function(b){return this.each(function(){var a=Object.create(k);a.init(b,this);d.data(this,"elevateZoom",a)})};d.fn.elevateZoom.options={zoomActivation:"hover",zoomEnabled:!0,preloading:1,zoomLevel:1,scrollZoom:!1,scrollZoomIncrement:0.1,minZoomLevel:!1,maxZoomLevel:!1,easing:!1,easingAmount:12,lensSize:200,
zoomWindowWidth:400,zoomWindowHeight:400,zoomWindowOffetx:0,zoomWindowOffety:0,zoomWindowPosition:1,zoomWindowBgColour:"#fff",lensFadeIn:!1,lensFadeOut:!1,debug:!1,zoomWindowFadeIn:!1,zoomWindowFadeOut:!1,zoomWindowAlwaysShow:!1,zoomTintFadeIn:!1,zoomTintFadeOut:!1,borderSize:4,showLens:!0,borderColour:"#888",lensBorderSize:1,lensBorderColour:"#000",lensShape:"square",zoomType:"window",containLensZoom:!1,lensColour:"white",lensOpacity:0.4,lenszoom:!1,tint:!1,tintColour:"#333",tintOpacity:0.4,gallery:!1,
galleryActiveClass:"zoomGalleryActive",imageCrossfade:!1,constrainType:!1,constrainSize:!1,loadingIcon:!1,cursor:"default",responsive:!0,onComplete:d.noop,onZoomedImageLoaded:function(){},onImageSwap:d.noop,onImageSwapComplete:d.noop}})(jQuery,window,document);

// MIKE STOLLER'S CODE STARTS BELOW

//
// ON PAGE LOAD
//
//////////////////////////////////////////////
$( document ).ready(function()
{
  // LOAD ALL PRODUCTS 
  // WE'VE LOADED THE FIRST PAGE SO PAGE COUNT IS 1
  var page_count = 1;
  // IN A HIDDEN DIV FROM LIQUID
  // USED TO COMPARE AGAINST PAGE COUNT
  var max_pages = parseInt($("#max-pages").html());
  // PASS ABOVE TWO VARS TO LOADING FUNCTION BELOW
  more_products(page_count, max_pages);

  // SPLIT THE URL FOR SHAREABLE MODALS
  // ADAPTED FROM http://www.designchemical.com/blog/index.php/jquery/8-useful-jquery-snippets-for-urls-querystrings/
  var url_split = [], hash;
  var url_array = document.URL.split('?')[1];
  if(url_array != undefined)
  {
    url_array = url_array.split('&');
    for(var i = 0; i < url_array.length; i++)
    {
      hash = url_array[i].split('=');
      url_split.push(hash[1]);
      url_split[hash[0]] = hash[1];
    }
  }
  // IF URL HAS ?poster= LOAD MODAL WITH THAT POSTER
  if( url_split.poster )
  {
    jQuery.getJSON("/products/" + url_split.poster + ".js", function(product) 
    {
      // EMPTY TO PREVENT EMPTY MODAL POP UPS
      // ONLY SHOW ON SUCCESS
    }).success(function( product )
    {
      container_clear();
      $(".swissted-modal-content").append( swissted_product( product ) );
      instantiate_selectors( product );
      instantiate_zoom();
      $(".swissted-modal").fadeIn( "slow" );
    });
  }
  // IF CART, SEARCH, SHIPPING, OR CONTACT IN URL
  // SAME AS CLICKING CORRESPONDING NAV BUTTON
  if( url_split.cart )
  {
    $("#nav-view-cart").click();
  }
  if( url_split.search )
  {
    $("#nav-search").click();
  }
  if( url_split.contact )
  {
    $("#nav-contact").click();
  }
  if( url_split.shipping )
  {
    $("#nav-shipping").click();
  }

});

// CLICK BROWSER BACK BUTTON SHOW APPROPRIATE MODAL
window.onpopstate = function(event) 
{    
  if(event && event.state) 
  {
    location.reload(); 
  }
}

// DECLARE GLOBAL LAST PRODUCT VARIABLE
// FOR USE IN CART.. GLOBAL SO WE CAN UPDATE CART AND STILL USE
var last_product;


//
// REUSABLE FUNCTIONS
//
//////////////////////////////////////////////


// AJAX LOADER FUNCTIONS
$( document ).ajaxStart(function() 
{
  // $("#ajax-loader").show();
});
$( document ).ajaxStop(function() 
{
  // $("#ajax-loader").hide();
});

// FUNCTION USED TO GENERATE PREVIOUS/NEXT LINKS FROM ARRAY
function find(key, array) 
{
  var results = [];
  for (var i = 0; i < array.length; i++) {
    if (array[i].indexOf(key) == 0) {
      results.push(array[i - 1]);
      results.push(array[i + 1]);
    }
  }
  return results;
};

// SHUFFLE ARRAY JAVASCRIPT
// FROM http://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex ;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

// ENABLE ZOOM ON MODAL IMAGES
function instantiate_zoom()
{
  $("#zoom").elevateZoom(
  { 
    zoomType : "inner",
    cursor: "crosshair",
    zoomWindowFadeIn: 500
  });
  
}

// SPLIT VARIANTS/OPTIONS
// PER https://docs.shopify.com/support/your-website/themes/can-i-make-my-theme-use-products-with-multiple-options#instantiate-shopify-optionselector
function instantiate_selectors( product )
{
	jQuery(function($) 
	{
	  new Shopify.OptionSelectors("productSelect", { product: product, onVariantSelected: selectCallback });
	});
}

// CALLBACK FUNCTION FOR OPTION SELECTED
// ALSO PER https://docs.shopify.com/support/your-website/themes/can-i-make-my-theme-use-products-with-multiple-options#instantiate-shopify-optionselector
var selectCallback = function(variant, selector) 
{
	
  if (variant) 
  {
    if (variant.available) 
    {
      // Selected a valid variant that is available.
      $('#add').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
    } 
    else 
    {
      // Variant is sold out.
      $('#add').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);        
    }
    // Whether the variant is in stock or not, we can update the price and compare at price.
    // if ( variant.compare_at_price > variant.price ) 
    // {
    //   $('#price-field').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
    // }
    // else 
    // {
    $('.price').html( Shopify.formatMoney(variant.price, "") );
    // }        
  }
  else 
  {
    // variant doesn't exist.
    $('#add').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
  }
}


// FUNCTION THAT OUTPUTS PRODUCT
var swissted_product = function ( product )
{
  var previous_product = find(product.handle, swissted_poster_handles)[0];  
  var next_product = find(product.handle, swissted_poster_handles)[1];
  
  var product_output = "<div class='product-modal-container'>";
  product_output += "<img class='product-image animated fadeIn' src='" + product.images[0] + "' data-zoom-image='" + product.images[0] + "' id='zoom' >";
  
  product_output += "<div class='product-modal-container-data'>";
  
  // PREV/NEXT LINKS
  product_output += "<div class='modal-nav'>"; 
  product_output += "<a href='?poster=" + previous_product + "' id='previous-product'>prev</a>"
  product_output += "<span id='modal-nav-seperator'>/</span>";
  product_output += "<a href='?poster=" + next_product + "' id='next-product'>next</a>";
  product_output += "</div>"; // END .modal-nav

  // HIDDEN CURRENT PRODUCT USED IN AJAX CALLS
  product_output += "<a href='?poster=" + product.handle + "' id='this-product' style='display:none'>" + product.handle + "</a>";
  
  // MOBILE ONLY EXTRA TITLE/LINK/IMAGE
  product_output += "<div class='product-modal-image-mobile'>";
  product_output += "<h2>" + product.title + "</h2>";
  product_output += "<a href='#poster-info'>view print details</a>";
  product_output += "<img src='" + product.images[0] + "' class='animated fadeIn'>";
  product_output += "</div>";

  product_output += "<div id='poster-info'>";

  // PRODUCT TITLE 
  product_output += "<h2>" + product.title + "</h2>";
  // START OF ADD TO CART FORM
  product_output += "<form  action='/cart/add' enctype='multipart/form-data' id='swissted-add-to-cart-form'>";
  product_output += "<select name='id' id='productSelect'>";
  
  $.each ( product.variants, function(key, value){
    product_output += "<option value='" + value.id + "'>" + value.title + " - $" + value.price/100 + "</option>";
  });

  product_output += "</select>";
  product_output += "<h3 class='price'>$" + product.price / 100 + "</h3>";
  product_output += "<button id='swissted-add-to-cart' class='button add-to-cart-button'>";
  product_output += "<span id='swissted-add-to-cart-text'>add to cart</span>";
  product_output += "</button>";
  product_output += "</form>";

  // SPLIT DESCRIPTION INTO USABLE ARRAY FOR ABOUT/SHIPPING DROPDOWNS
  var description_as_array = product.description.split(/<\/?(?:div|p|br)[^>]*>\s*/im);
  
  // ABOUT PRINT, SHIPPING, SHARE DROPDOWNS
  // ABOUT PRINT DROPDOWN
  product_output += "<div class='about-print-dropdown'>";
  product_output += "<a class='dropdown-link no-select' id='about-dropdown-link'><span>+</span> about the prints</a>";
  product_output += "<div class='dropdown hidden' id='about-dropdown'>";
  product_output += "<p>" + description_as_array[1] + "</p>";
  product_output += "</div>";
  product_output += "</div>";
  // SHIPPING INFO DROPDOWN
  product_output += "<div class='shipping-info-dropdown'>";
  product_output += "<a class='dropdown-link no-select' id='shipping-dropdown-link'><span>+</span> shipping</a>";
  product_output += "<div class='dropdown hidden' id='shipping-dropdown'>";
  product_output += "<p>" + description_as_array[3] + "</p>";
  product_output += "<p>" + description_as_array[5] + "</p>";
  product_output += "<p>" + description_as_array[7] + "</p>";
  product_output += "</div>";
  product_output += "</div>";
  
  // SHARE PRINT DROPDOWN
  product_output += "<div class='share-print-dropdown'>";
  product_output += "<a class='dropdown-link no-select' id='share-dropdown-link'><span>+</span> share</a>";
  product_output += "<div class='dropdown hidden' id='share-dropdown'>";
  product_output += "<p>Use the link below to share this poster with your friends:</p>";
  product_output += "<a href='" + swissted_page_url + "/?poster=" + product.handle + "'>" + product.title + "</a>";
  product_output += "</div>";
  product_output += "</div>";

	product_output += "</div>"; // PRINT DETAILS CONTAINER  

  product_output += "</div>"; // CLOSES PRODUCT MODAL DATA CONTAINER
  product_output += "</div>"; // CLOSES PRODUCT MODAL CONTAINER
  return product_output;
}

// FUNCTION THAT OUTPUTS CART 
// USED IN A FEW DIFFERENT AJAX REQUESTS BELOW
var swissted_cart = function( cartdata )
{
  var cart_output = "<div class='cart-modal-container'>";
  cart_output += "<h2>cart</h2>";
  
  // BACK BUTTON IN CART
  if (last_product !== undefined)
  {
	  cart_output += "<a href='#' id='cart-back' class='cart-back'> <span><</span> back</a>"; 
  }
  
  if (cartdata.items != '')
  {
    $(cartdata.items).each(function()
    {
    	var price = ((this.quantity * this.price)/100).toFixed(2);
      // console.log(price);
      cart_output += "<div class='cart-item'>";
      cart_output += "<a href='?poster=" + this.handle + "' data-product-handle='" + this.handle + "' class='product-rollover'>";
      cart_output += "<img src='" + this.image + "' width='148'>";
      cart_output += "</a>";
      
      cart_output += "<div class='product-info-container'>";
      cart_output += "<a href='?poster=" + this.handle + "' data-product-handle='" + this.handle + "' class='product-rollover'>";
      cart_output += "<h3 class='product-title'>" + this.product_title + "</h3>";
      cart_output += "</a>";
      cart_output += "<h4 class='variant-title'>" + this.variant_title + "</h4>";
      
      cart_output += "<label>QTY <input value='" + this.quantity + "' id='" + this.id + "' class='qty-input' name='product-qty'></label>";
      cart_output += "<a class='swissted-update-cart' href='#' data-product-id='" + this.id + "'>update</a>";
      cart_output += "</div>";
      cart_output += "<p class='price'>$" + price + "</p>";
      cart_output += "</div>";
      
    });
  }  
  else
  {
    cart_output += "<div class='cart-item'>";
    cart_output += "<p>Nothing in your cart yet.</p>";
    cart_output += "<a href='#' id='empty-cart-search'>Search our catalog now.</a>";
    cart_output += "</div>";
  }
  cart_output += "<hr>";
  cart_output += "<div class='cart-bottom'>";
  cart_output += "<p class='subtotal'>subtotal $" + cartdata.total_price/100 + "</p>";
  cart_output += "<a href='/checkout' class='button checkout-button'>checkout</a>";
  cart_output += "</div>";
  cart_output += "<div>";

  return cart_output;
}

// AJAX GET MORE PRODUCTS
function more_products (page_count, max_pages)
{
	page_count++;
  $.ajax
  ({
   type: "GET",
   url: "/?page=" + page_count,
   dataType: "html",
   success: function(data)
   {
      // GET THE PRODUCT CONTAINERS FROM THE PAGINATED PAGES
      var filtered_data = $(data).find(".product-container");

      // ADD THE NEW PRODUCT CONTAINERS TO THE PAGE
      $(".products-container").append(filtered_data);

      // ADDS THE HANDLE TO THE POSTER ARRAY
      // THIS DATA IS USED FOR
      // PREVIOUS/NEXT BUTTONS IN MODALS
      $.each( filtered_data, function( key, value )
      {
        swissted_poster_handles.push( this.id );
      });
      // console.log(swissted_poster_handles);
      modal_nav_check();

      // IF THERE ARE MORE PAGES TO LOAD RUN THIS FUNCTION AGAIN
      if(page_count <= max_pages)
		  {
		  	more_products (page_count, max_pages);
		  }
    }
  });
}

// CLEAR THE MODAL
var container_clear = function()
{
  $(".product-modal-container").fadeOut( "slow" ).remove();
  $(".cart-modal-container").fadeOut( "slow" ).remove();
  $(".search-modal-container").fadeOut( "slow" ).remove();
  $(".contact-modal-container").fadeOut( "slow" ).remove();
  $(".shipping-modal-container").fadeOut( "slow" ).remove();
}


// CLOSE MODAL FUNCTION
var close_modal = function()
{
  $(".swissted-modal").addClass( "animated fadeOut" );
  window.history.pushState( "Swissted", "Swissted", "/");
  container_clear();
  $(".zoomContainer").remove();
  last_product = undefined;
}

// CHECKS IF PRODUCT PREV/NEXT LINKS ARE UNDEFINED
// IF SO TRY TO UPDATE THEM
// IF CAN'T BE UPDATED, HIDE
var modal_nav_check = function()
{
  // VARIABLE TO DETERMINE WHETER TO SHOW / BETWEEN PREV AND NEXT
  var nav_seperator = true;

  if( $("#next-product").attr("href", "?product=undefined"))
  {
    var next_product = find($("#this-product").html(), swissted_poster_handles)[1];
    if(next_product)
    {
      $("#next-product").attr("href", "?poster=" + next_product);
      $("#next-product").show();
    }
    else
    {
      $("#next-product").hide();
      nav_seperator = false;
    }
  }

  if( $("#previous-product").attr("href", "?product=undefined"))
  {
    var previous_product = find($("#this-product").html(), swissted_poster_handles)[0];
    // alert(previous_product);
    if(previous_product)
    {
      $("#previous-product").attr("href", "?poster=" + previous_product); 
      $("#previous-product").show();
    }
    else
    {
      $("#previous-product").hide();
      nav_seperator = false;
    }
  }

  if (nav_seperator)
  {
    $("#modal-nav-seperator").show();
  }else
  {
    $("#modal-nav-seperator").hide();
  }
}

//
// ON CLICK/KEYUP FUNCTIONS
//
//////////////////////////////////////////////


// CLICK THE CLOSE BUTTON IN THE MODAL
$(".close-swissted-modal").click(function(e)
{
  close_modal();
});
// HIT ESCAPE CLOSE MODAL
$(document).on( "keyup", function(e) {
  if (e.keyCode == 27) 
  {
    close_modal();
  }
});

// ON CLICK OF THE VIEW PRINT BUTTON
$(document).on("click", ".product-rollover", function(e)
{
  e.preventDefault();
  
  var product = $(this).data("product-handle");

  jQuery.getJSON("/products/" + product + ".js", function(product) 
  {    
    container_clear();
    $(".swissted-modal-content").append( swissted_product( product ) );
    instantiate_selectors( product );
    modal_nav_check();

    window.history.pushState( product.title, product.title, "/?poster=" + product.handle);
  }).done(function()
  {
    instantiate_zoom();
  });
  $(".swissted-modal").addClass( "animated fadeIn" );
  $(".swissted-modal").show();
});

// NEXT PRODUCT LINK
$(document).on("click", "#next-product", function(e)
{
  e.preventDefault();
  
  // GET NEXT PRODUCT FROM URL
  var next_product = $(this).attr("href").split("=", 2);
  next_product = next_product[1];
  
  jQuery.getJSON("/products/" + next_product + ".js", function(product) 
  {
    // EMPTY TO PREVENT EMPTY MODAL POP UPS
    // ONLY SHOW ON SUCCESS
  }).success(function( product )
  {
    container_clear();
    $(".swissted-modal-content").append( swissted_product( product ) );
    instantiate_selectors( product );
    modal_nav_check();

    $(".swissted-modal").fadeIn( "slow" );;
    instantiate_zoom();
    window.history.pushState( product.title, product.title, "/?poster=" + product.handle);  
  });
});

// PREVIOUS PRODUCT LINK
$(document).on("click", "#previous-product", function(e)
{
  e.preventDefault();
  // GET PREVIOUS PRODUCT FROM URL
  var previous_product = $(this).attr("href").split("=", 2);
  previous_product = previous_product[1];
  
  jQuery.getJSON("/products/" + previous_product + ".js", function(product) 
  {
    // EMPTY TO PREVENT EMPTY MODAL POP UPS
    // ONLY SHOW ON SUCCESS
  }).success(function( product )
  {
    container_clear();
    $(".swissted-modal-content").append( swissted_product( product ) );
    instantiate_selectors( product );
    modal_nav_check();

    $(".swissted-modal").fadeIn( "slow" );;
    instantiate_zoom();
    window.history.pushState( product.title, product.title, "/?poster=" + product.handle);  
  });
});

// IF CART IS EMPTY THERE IS A LINK TO SEARCH 
// THIS FUNCTION ON CLICK CALLS THE FUNCTION BELOW
// CLICKING SEARCH IN NAV
$(document).on("click", "#empty-cart-search", function(e)
{
  e.preventDefault();
  $("#nav-search").trigger("click");
});

// HIT ENTER IN SEARCH BOX TRIGGER CLICK FUNCTION BELOW
$(document).on( "keyup", "#swissted-search-input", function(e) 
{
  if (e.keyCode == 13) 
  {
    $("#search-submit").trigger("click");
  }
});

// AJAX SEARCH ON CLICK
$(document).on("click", "#search-submit", function(e)
{
  
  e.preventDefault();

  // EMPTY ANY SEARCH RESULTS
  // NOT container_clear();
  // TO KEEP SEARCH BAR BUT REMOVE RESULTS
  $(".search-modal-results").remove();

  $.ajax({
    url: "/search?q=" + $("#swissted-search-input").val() + "*&type=product&view=json", 
    dataType: "json",
    success: function( data ) {
      var search_output = "<div class='search-modal-results'>";
      if (data == "")
      {
        search_output += "<p>no results found!</p>";
      }
      else
      {
        $.each( data, function()
        {
          search_output += "<div class='product-container' >";
          search_output += "<img src='" + this.featured_image + "' width='102' class='product-image'>";
          search_output += "<a class='product-rollover' data-product-handle='" + this.handle + "'>";
          search_output += "<p class='product-rollover-title'>" + this.title + "</p>";
          search_output += "<span class='button product-rollover-button'>view print</span>";
          search_output += "</a>";
          search_output += "</div>";
        });
      }
      search_output += "</div>";
      $( ".popular-searches-title" ).before( search_output );
    }
  });
});

// AJAX ADD TO CART FUNCTION
$(document).on("click", "#swissted-add-to-cart", function(e)
{
  e.preventDefault();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('form[action="/cart/add"]').serialize(),
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cartdata)
        {   
          // EMPTY THE MODAL
          // container_clear();
          $(".product-modal-container").addClass("animated fadeOutLeft");
          $(".product-modal-container").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function()
          {  
          	last_product = $("#this-product").html();
            // console.log(last_product);

            $(".product-modal-container").removeClass("animated fadeOutLeft");
            $(".product-modal-container").remove();
            $(".zoomContainer").remove();

            
            // CART OUTPUT FROM AJAX RESPONSE          
            $( ".swissted-modal-content" ).append( swissted_cart( cartdata ) );
            $( ".cart-modal-container" ).addClass("animated fadeInRight").show();
            $( ".cart-modal-container" ).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function()
            {
              $(this).removeClass("animated fadeInRight")
            });

            // UPDATE CART COUNT IN NAV
            $( "#nav-view-cart span" ).html( cartdata.item_count );

            // UPDATE URL
            window.history.pushState( "Swissted Cart","Swissted Cart", "/?cart=1");
          });
        }
      });
    }
  });  
});

// AJAX UPDATE CART FUNCTION
$(document).on("click", ".swissted-update-cart", function(e)
{
  e.preventDefault();
  var product = $(this).data("product-id");
  var quantity = $("#" + product).val();
  
  $.ajax(
  {
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: 
    {
      quantity: quantity,
      id: product
    },
    success: function(response)
    {
      $.ajax(
      {
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cartdata)
        {       
          
          // EMPTY THE MODAL
          container_clear();

          // UPDATE CART COUNT IN NAV
          $( "#nav-view-cart span" ).html( cartdata.item_count );
          
          // CART OUTPUT FROM AJAX RESPONSE
          $(".swissted-modal-content").append( swissted_cart( cartdata ) );

        }
      });
    }
  });
});

// ON CLICK BACK BUTTON IN CART
$(document).on("click", "#cart-back", function(e)
{
	e.preventDefault();
	// alert(last_product);

	jQuery.getJSON("/products/" + last_product + ".js", function( product ) 
  {
    // EMPTY TO PREVENT EMPTY MODAL POP UPS
    // ONLY SHOW ON SUCCESS

  }).success(function( product )
  {
    //container_clear();
    $(".cart-modal-container").addClass("animated fadeOutRight");
    $(".cart-modal-container").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function()
    {  
    	// last_product = $("#this-product").html();
      // console.log(last_product);

      $(".cart-modal-container").removeClass("animated fadeOutRight");
      $(".cart-modal-container").remove();
      // $(".zoomContainer").remove();

      
      // CART OUTPUT FROM AJAX RESPONSE          
      $(".swissted-modal-content").append( swissted_product( product ) );

      $( ".product-modal-container" ).addClass("animated fadeInLeft").show();
      instantiate_selectors( product );
      $( ".product-modal-container" ).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function()
      {
      	instantiate_zoom();
	      modal_nav_check();
	      
        $(this).removeClass("animated fadeInLeft")
      });

      // UPDATE URL
	    window.history.pushState( product.title, product.title, "/?poster=" + product.handle);  
    });
  });
});

//
// CLICK FUNCTIONS FOR MODAL DROP DOWNS
//
//////////////////////////////////////////////


// CLICK ABOUT DROPDOWN
$(document).on("click", "#about-dropdown-link", function (e)
{
  e.preventDefault();
  if ($("#about-dropdown").hasClass("hidden"))
  { 
    $("#about-dropdown").show();
    $("#about-dropdown").removeClass("hidden");
    $("#about-dropdown-link > span").html("-");
  }
  else
  {
    $("#about-dropdown").hide();
    $("#about-dropdown").addClass("hidden");
    $("#about-dropdown-link > span").html("+"); 
  }
});

// CLICK SHIPPING DROPDOWN
$(document).on("click", "#shipping-dropdown-link", function (e)
{
  e.preventDefault();
  if ($("#shipping-dropdown").hasClass("hidden"))
  { 
    $("#shipping-dropdown").show();
    $("#shipping-dropdown").removeClass("hidden");
    $("#shipping-dropdown-link > span").html("-");
  }
  else
  {
    $("#shipping-dropdown").hide();
    $("#shipping-dropdown").addClass("hidden");
    $("#shipping-dropdown-link > span").html("+");
  }
  
});

// CLICK SOCIAL SHARE DROPDOWN
$(document).on("click", "#share-dropdown-link", function (e)
{
  e.preventDefault();
  if ($("#share-dropdown").hasClass("hidden"))
  { 
    $("#share-dropdown").show();
    $("#share-dropdown").removeClass("hidden");
    $("#share-dropdown-link > span").html("-");
  }
  else
  {
    $("#share-dropdown").hide();
    $("#share-dropdown").addClass("hidden");
    $("#share-dropdown-link > span").html("+");
  }
});

// CHANGE PRICE SHOWN IN MODAL ON SELECT CHANGE
$(document).on("change", "#productSelect", function()
{
  var chosen_product = $("#productSelect option:selected").text().split("$");
  $(".price").html("$" + chosen_product[1]);
});


//
// ON NAV CLICKS
//
//////////////////////////////////////////////

// NAV VIEW CART FUNCTION
$(document).on("click", "#nav-view-cart", function(e)
{
  e.preventDefault();
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function( cartdata ){
      
      // EMPTY THE MODAL
      container_clear();
      
      // CART OUTPUT FROM AJAX RESPONSE
      $(".swissted-modal-content").append( swissted_cart( cartdata ) );
      $(".swissted-modal").fadeIn( "slow" );
      window.history.pushState( "Swissted Cart","Swissted Cart", "/?cart=1");
    }
  });
});

// NAV SEARCH CLICK
$(document).on("click", "#nav-search", function(e)
{
  e.preventDefault();
  // MAKE SURE MODAL IS EMPTY
  container_clear();
  //SHOW MODAL
  $(".swissted-modal").fadeIn( "slow" );
  
  // GET AN PRODUCTS WE'VE ALREADY LOADED
  var product_array = $(".product-container").get();
  // SHUFFLE THAT ARRAY SO IT SEEMS RANDOM
  shuffle(product_array);


  var swissted_search = "<div class='search-modal-container animated fadeIn'>";
  swissted_search += "<div class='swissted-search-container'>";
  swissted_search += "<input type='text' id='swissted-search-input' placeholder='search...'>";
  swissted_search += "<button class='button search-button' id='search-submit'>go</button>";
  swissted_search += "</div>"; // END #swissted-search-container CONTAINS THE INPUT
  
  swissted_search += "<p class='popular-searches-title'>popular searches</p>";
  swissted_search += "<div class='popular-searches'>";
  
  // OUT PUT FROM PRODUCT ARRAY FOR POPULAR SEARCHES
  for(product = 1; product < 13; product++)
  {
  	swissted_search += "<div class='product-container'>";
  	swissted_search += $(product_array[product]).html();
  	swissted_search += "</div> ";
  }
  
  swissted_search += "</div>"; // END .popular-searches
  swissted_search += "</div>"; // END #search-modal-container WHERE WE PUT OUR SEARCH RESULTS
  $(".swissted-modal-content").append( swissted_search ); 
  // UPDATE URL
  window.history.pushState( "Swissted Search","Swissted Search", "/?search=1");
});

// SHIPPING 
$(document).on("click", "#nav-shipping", function(e)
{
  e.preventDefault();
  // MAKE SURE MODAL IS EMPTY
  container_clear();
  //SHOW MODAL
  $(".swissted-modal").fadeIn( "slow" );
  
  var swissted_shipping = "<div class='shipping-modal-container'>";
  swissted_shipping += "<h2>shipping</h2>";
  swissted_shipping += "<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus nisi, distinctio illum ad quia fuga. Voluptas nihil excepturi dicta consectetur ex illum, error neque quia et temporibus, maiores, velit, accusamus!</p>";
  swissted_shipping += "</div>";
  
  $(".swissted-modal-content").append( swissted_shipping ); 
  window.history.pushState( "Swissted Shipping","Swissted Shipping", "/?shipping=1");
});

// CONTACT 
$(document).on("click", "#nav-contact", function(e)
{
  e.preventDefault();
  // MAKE SURE MODAL IS EMPTY
  container_clear();
  //SHOW MODAL
  $(".swissted-modal").fadeIn( "slow" );;

  var swissted_contact = "<div class='contact-modal-container'>";
  swissted_contact += "<div class='contact-content-container'>";
  swissted_contact += "<h2>contact</h2>";
  swissted_contact += "<a href='mailto:info@swissted.com'>info@swissted.com</a>";
  swissted_contact += "</div>";
  swissted_contact += "<div class='faq-content-container'>";
  swissted_contact += "<h2>faqs</h2>";
  swissted_contact += "<p class='faq-question'>when does my order ship?</p>";
  swissted_contact += "<p class='faq-answer'>your order ships whenever we say it ships ok!</p>";

  swissted_contact += "</div>";
  swissted_contact += "</div>";
  
  $(".swissted-modal-content").append( swissted_contact ); 
  window.history.pushState( "Swissted Contact","Swissted Contact", "/?contact=1");
});

//
// ON ANIMATION COMPLETE
//
//////////////////////////////////////////////

// FUNCTION THAT RUNS ON MODAL ANIMATION COMPLETE
// REMOVES ANIMATION CLASSES EVERYTIME THEY FINISH
// IF CLASS WAS FADEOUT, HIDES THE MODAL
$(".swissted-modal").on("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function()
{
  if($(".swissted-modal").hasClass("fadeOut"))
  {
    $(".swissted-modal").hide();
  }
  $(".swissted-modal").removeClass( "animated fadeOut fadeIn" );
});